@let chart = nemChart(); @let value = chartValue(); @let freq = titleFrequency(); @let region = titleRegion(); @let
isResizing = resizing(); @let isDialog = dialogVisible(); @if (chart && value) { @if (previewMode()) {
<div class="relative">
  <div class="absolute top-[-1.25rem] right-0">
    <div class="logo-placeholder w-32 h-8 bg-contain bg-no-repeat bg-center"></div>
  </div>

  @if (!isDialog && !isResizing && !chart.loading) {
  <nem-plot [options]="value.options" [hideLegend]="chart.hideLegend"></nem-plot>
  <nem-plot [options]="chartBrush()"></nem-plot>
  <div class="flex items-center justify-center">
    <span class="font-semibold text-center text-slate-600">
      {{ value.options?.title?.text }} - {{ freq }} {{ region }}
    </span>
  </div>
  } @else {
  <div class="p-2">
    <nem-shimmer [text]="isResizing ? 'Rendering' : 'Loading data'"></nem-shimmer>
  </div>
  }
</div>

} @else {
<nem-main>
  <div
    class="flex flex-col h-full w-full bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden transition-all duration-300 hover:shadow-md">
    <div class="grid grid-cols-3 items-center px-4 py-2 border-b border-slate-50 bg-slate-50/50">
      <div class="flex items-center justify-start overflow-hidden">
        <span
          class="font-semibold text-sm text-slate-700 truncate"
          [title]="value.options?.title?.text + ' - ' + freq + region">
          {{ value.options?.title?.text }} - {{ freq }} {{ region }}
        </span>
      </div>

      <div class="flex items-center justify-center">
        <div class="logo-placeholder w-28 h-8 bg-contain bg-no-repeat bg-center"></div>
      </div>

      <div class="flex items-center justify-end gap-2">
        <nem-chart-toolbar
          [chartTypeValue]="chart.chartType"
          (chartTypeValueChange)="chartTypeChange($event)"
          (toggleTableViewChange)="toggleTableView()"
          (exportToCSVChange)="chart.exportToCSV()"
          (focusModeChange)="redirectToFocusmode()"
          (dialogVisibleChange)="dialogVisible.set($event)">
        </nem-chart-toolbar>
      </div>
    </div>

    <div class="flex items-stretch gap-4 p-2 relative flex-1">
      <ng-content></ng-content>

      <div class="flex-1 w-full overflow-hidden">
        @if (!chart.tabular.tabularView) { @if (!isResizing && !chart.loading && !isDialog) {
        <div class="w-full h-full min-h-[400px]">
          <nem-plot [options]="value.options" [hideLegend]="chart.hideLegend"></nem-plot>
          <nem-plot [options]="chartBrush()"></nem-plot>
        </div>
        } @else {
        <div class="w-full h-full min-h-[400px] flex items-center justify-center">
          <nem-shimmer class="w-full" [text]="isResizing ? 'Rendering' : 'Loading data'"></nem-shimmer>
        </div>
        } } @else {
        <p-splitter
          styleClass="min-h-[450px] w-full border-0"
          [panelSizes]="chart.tabular.panelSizes"
          (onResizeStart)="onResizeStart()"
          (onResizeEnd)="onResizeEnd()"
          layout="horizontal">
          <ng-template pTemplate>
            <div class="w-full h-full">
              @if (!isDialog && !isResizing && !chart.loading) {
              <nem-plot [options]="value.options" [hideLegend]="chart.hideLegend"></nem-plot>
              <nem-plot [options]="chartBrush()"></nem-plot>
              } @else {
              <nem-shimmer class="w-full" [text]="isResizing ? 'Rendering' : 'Loading data'"></nem-shimmer>
              }
            </div>
          </ng-template>

          <ng-template pTemplate>
            <nem-tabular
              class="w-full h-full"
              [loading]="chart.loading"
              [tabular]="chart.tabular"
              [(syncScrolling)]="chart.syncWithTabularScrolling"
              [dateFormat]="chart.dateFormat">
            </nem-tabular>
          </ng-template>
        </p-splitter>
        }
      </div>
    </div>
  </div>
</nem-main>
} @if (isDialog) {
<p-dialog
  [modal]="true"
  [attr.id]="chart.containerId"
  (onResizeEnd)="refresh()"
  (onMaximize)="refresh()"
  [(visible)]="dialogVisible"
  [maximizable]="false"
  [style]="{ width: '90vw' }">
  <ng-template pTemplate="header">
    <span class="flex items-center gap-3">
      <p-button
        styleClass="p-button-rounded p-button-text p-button-sm snapshot-button"
        pTooltip="Capture snapshot"
        tooltipPosition="top"
        icon="pi pi-clone"
        [disabled]="capturePending()"
        [loading]="capturePending()"
        (onClick)="takeSnapshot(value.options?.title?.text, chart.containerId)">
      </p-button>
      <span class="panel-title font-semibold text-lg text-slate-800">
        {{ value.options?.title?.text }} - {{ freq }} {{ region }}
      </span>
    </span>
    <div
      class="logo-placeholder logo-placeholder-in-dialog right-[8rem] w-32 h-8 bg-contain bg-no-repeat bg-center"></div>
  </ng-template>

  <div class="mt-4">
    <nem-plot [options]="value.options" [hideLegend]="chart.hideLegend"></nem-plot>
  </div>
</p-dialog>
} }
